import { gql } from "@apollo/client"

const JOB_NOTES_FIELDS = gql`
  fragment JobNotesFields on JobProcessStepNote {
    id
    text
    author {
      id
      fullName
      firstName
      lastName
      avatar {
        key
      }
    }
    uploads {
      id
      key
      fileName
      fileGroup
      fileSize
    }
    jobStep {
      ... on CheckboxJobStep {
        id
        name
      }
      ... on DateTimeJobStep {
        id
        name
      }
      ... on FilesJobStep {
        id
        name
      }
      ... on InstructionJobStep {
        id
        name
      }
      ... on LongTextJobStep {
        id
        name
      }
      ... on MultipleChoiceJobStep {
        id
        name
      }
      ... on NumberJobStep {
        id
        name
      }
      ... on NumberRatingJobStep {
        id
        name
      }
      ... on PhotosJobStep {
        id
        name
      }
      ... on ProcessJobStep {
        id
        name
      }
      ... on SectionJobStep {
        id
        name
      }
      ... on SelectionJobStep {
        id
        name
      }
      ... on SignatureJobStep {
        id
        name
      }
      ... on TemperatureTimerJobStep {
        id
        name
      }
      ... on TextJobStep {
        id
        name
      }
      ... on TouchpointJobStep {
        id
        name
      }
    }
    createdAt
  }
`

export { JOB_NOTES_FIELDS }
